 export enum NiveauValidationEnum {
NonDefini = 0,
Niveau_1 = 1,
Niveau_2 = 2,
}


// WEBPACK FOOTER //
// ./src/dto/GenApi.iNotPaie.Dto/NiveauValidationEnum.ts